<template>
  <div id="course-detail">
    <vx-card>
      <div class="vx-row course-info">
        <div class="vx-col md:w-1/4 w-full mb-4 flex justify-center overflow-hidden">
          <img style="max-height: 280px" :src="course.cover" alt="">
        </div>
        <div class="vx-col md:w-3/4">
          <h3>{{ course.name }}</h3>
          <div class="flex my-2">
            <span class="title">课程简介：</span>
            <p>{{ course.brief }}</p>
          </div>
          <div class="flex my-2">
            <span class="title">总课程数：</span>
            <p>{{ course.hour }} 节</p>
          </div>
          <div class="flex my-2">
            <span class="title">课程分类：</span>
            <p>{{ course.cate.name }}</p>
          </div>
        </div>
      </div>
      <vs-tabs>
        <vs-tab label="课程大纲" class="py-1 px-0">
          <div class="chapter-list" v-if="course.chapters.length > 0">
            <div class="chapter-item flex w-full px-2 py-4 cursor-pointer" 
              :class="{'disabled': !chapter.grant}"
              v-for="chapter in course.chapters" 
              :key="chapter.id"
              @click="showChapterDetail(chapter.id, chapter.grant)"
            >
              <feather-icon :icon="chapter.grant ? 'PlayCircleIcon' : 'LockIcon'" svgClasses="h-6 w-6" class="ml-2 mr-4" />
              <div class="chapter-desc">
                <p class="title">{{ chapter.name }}</p>
                <p class="brief">课程简介：{{ chapter.brief }}</p>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import { courseDetail } from '@/api/course'
export default {
  components: {
  },
  data() {
    return {
      course: {
        id: 0,
        name: '',
        brief: '',
        hour: 0,
        cate: {
          name: ''
        },
        chapters: [],
      }
    }
  },
  created() {
    
  },
  mounted() {
    this.course.id = this.$route.query.id
    this.init()
  },
  computed: {
    
  },
  methods: {
    init() {
      courseDetail({id: this.course.id}).then(res => {
        if (res.code == 1) {
          this.course = res.data.course
          this.$route.meta.breadcrumb[2].title = this.course.name
        }
      })
    },
    showChapterDetail(id, grant) {
      if (!grant) return false;
      this.$router.push({path: '/courseCenter/detail', query: {id: id, courseId: this.course.id}})
    }
  },
  
  
}
</script>

<style lang="scss" scoped>
  .course-info {
    .title {
      color: #999;
      white-space: nowrap;
    }
  }
  .chapter-list {
    .chapter-item:hover {
      color: #fff;
      background: rgba(var(--vs-primary),1)!important;
      opacity: .8;
      .title {
        color: #fff;
      }
      .brief {
        color: #fff;
      }
    }
    .chapter-item.disabled {
      background: #eee;
      opacity: .8;
    }
    .chapter-item.disabled:hover {
      color: #626262;
      background: #eee !important;
      cursor: not-allowed !important;
      .title {
        color: #000;
      }
      .brief {
        color: #999;
      }
    }
    .title {
      color: #000;
      font-size: 14px;
      font-weight: 500;
    }
    .brief {
      color: #999;
    }
  }
  
</style>
